import dayjs from "dayjs";
import { parseDate, parseDateTime } from "@internationalized/date";
//#region src/DatePicker/DatePicker/DatePicker.lib.ts
const dateConverters = {
	toDateAria: (unixDate) => unixDate == null ? void 0 : parseDate(dayjs.unix(unixDate).format("YYYY-MM-DD")),
	toDateTimeAria: (unixDate) => unixDate == null ? void 0 : parseDateTime(dayjs.unix(unixDate).format("YYYY-MM-DDTHH:mm")),
	fromAria: (ariaDate) => ariaDate && dayjs(ariaDate.toString()).unix()
};
const dateIsValid = (date) => dayjs(date?.toString()).isValid();
//#endregion
export { dateConverters, dateIsValid };

//# sourceMappingURL=DatePicker.lib.js.map